import styled, { css } from 'styled-components';
import { ifNotProp, ifProp, palette } from 'styled-tools';

import { minWidth, units } from '@calm-web/design-system';

export const contentWrapperTabletMinHeight = '704px';

export const ContentWrapper = styled.div<{
	centerAlign?: boolean;
	isRevampRedempFlow?: boolean;
}>`
	color: ${palette('gray7')};
	display: flex;
	flex-direction: column;
	max-width: 460px;
	padding: ${ifProp('isRevampRedempFlow', `0 ${units(5)} ${units(2.5)}`, `${units(5)} ${units(2.5)}`)};
	border-radius: 16px;
	width: 100%;

	${ifNotProp(
		'isRevampRedempFlow',
		css`
			background-color: ${palette('white')};
			box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.15);

			${minWidth('desktop')} {
				margin-top: ${units(3.56)};
			}
		`,
	)}

	${ifProp(
		'isRevampRedempFlow',
		css`
			max-width: 460px;
		`,
	)}
	
	${ifProp(
		'centerAlign',
		css`
			text-align: center;
		`,
	)}

	${minWidth('tablet')} {
		margin: 0 auto;
		max-width: 560px;
		min-height: ${contentWrapperTabletMinHeight};
		padding: 0 ${units(4.44)} ${units(4.67)};
	}
`;
